import { Controller, useFormContext } from 'react-hook-form';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import { Select } from '@c/select';

import { AddUserForm } from '@t/user/components/add-user/field-values.schema';

const AddUserBody = () => {
  const { control, register } = useFormContext<AddUserForm>();
  const { ref: firstNameRef, ...firstName } = register('firstName');
  const { ref: middleNameRef, ...middleName } = register('middleName');
  const { ref: lastNameRef, ...lastName } = register('lastName');
  const { ref: titleRef, ...title } = register('title');
  const { ref: emailRef, ...email } = register('email');
  const { ref: cellPhoneRef, ...cellPhone } = register('cellPhone');
  const { ref: addressRef, ...address } = register('address');
  const { ref: cityRef, ...city } = register('city');
  const { ref: zipRef, ...zip } = register('zipCode');
  const { ref: passWordRef, ...passWord } = register('password');
  const { ref: confirmPasswordRef, ...confirmPassword } = register('confirmPassword');

  return (
    <FormGroup row>
      <Row className="mb-3">
        <h4>Basic Information</h4>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>First Name</Label>
        </Col>
        <Col>
          <Input
            {...firstName}
            innerRef={firstNameRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Middle Name</Label>
        </Col>
        <Col>
          <Input
            {...middleName}
            innerRef={middleNameRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Last Name</Label>
        </Col>
        <Col>
          <Input
            {...lastName}
            innerRef={lastNameRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Title</Label>
        </Col>
        <Col>
          <Input
            {...title}
            innerRef={titleRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Email</Label>
        </Col>
        <Col>
          <Input
            {...email}
            innerRef={emailRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>CellPhone</Label>
        </Col>
        <Col>
          <Input
            {...cellPhone}
            innerRef={cellPhoneRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <h4>Additional Information</h4>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Address</Label>
        </Col>
        <Col>
          <Input
            {...address}
            innerRef={addressRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>City</Label>
        </Col>
        <Col>
          <Input
            {...city}
            innerRef={cityRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>State</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="state"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={onChange}
                placeholder="Select State"
                value={value}
              />
            )}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Zip</Label>
        </Col>
        <Col>
          <Input
            {...zip}
            innerRef={zipRef}
            type="number"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <h4>Permissions</h4>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Role</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="role"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={onChange}
                placeholder="Select Role"
                value={value}
              />
            )}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Department</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="department"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={onChange}
                placeholder="Select Department"
                value={value}
              />
            )}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Client Group</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="department"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={onChange}
                placeholder="Select Client Group"
                value={value}
              />
            )}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Password</Label>
        </Col>
        <Col>
          <Input
            {...passWord}
            innerRef={passWordRef}
            type="text"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col sm={3}>
          <Label>Confirm Password</Label>
        </Col>
        <Col>
          <Input
            {...confirmPassword}
            innerRef={confirmPasswordRef}
            type="text"
          />
        </Col>
      </Row>
    </FormGroup>
  );
};

export default AddUserBody;
